// 9fbef606107a605d69c0edbcd8029e5d 
import { BONUS_POINTS_DAYS } from '../../../../constants/reducer.constants';

const BONUS_POINTS_DAYS_CONSTANTS = {
  GET_BONUS_DAYS: `${BONUS_POINTS_DAYS}GET_BONUS_DAYS`,
  APPLY_BONUS_DAYS: `${BONUS_POINTS_DAYS}APPLY_BONUS_DAYS`,
  SHOW_LOADER: `${BONUS_POINTS_DAYS}SHOW_LOADER`,
  SET_BONUS_DAYS_SUCCESS: `${BONUS_POINTS_DAYS}SET_BONUS_DAYS_SUCCESS`,
  SET_BONUS_DAYS_ERROR: `${BONUS_POINTS_DAYS}SET_BONUS_DAYS_ERROR`,
  GET_BONUS_DAYS_TTL: 0,
  FETCH_MODULEX_CONTENT: `${BONUS_POINTS_DAYS}FETCH_MODULEX_CONTENT`,
  SET_MODULEX_CONTENT: `${BONUS_POINTS_DAYS}SET_MODULEX_CONTENT`,
  BONUS_DETAILS_REF_LABEL: 'Bonus Points Days Details',
  VIEWS: {
    EDIT: 'edit',
    READ: 'read',
  },
};

export default BONUS_POINTS_DAYS_CONSTANTS;
